// Les consignes sont du Markdown. Seul un bloc délimité par ``` est affiché comme du code :
// deviner le code à partir des mots (« using UnityEngine », « public class »…) faisait passer
// des consignes entières dans un éditeur dès qu'elles citaient ces mots.
export type InstructionPart =
  | { kind: 'text'; text: string }
  | { kind: 'code'; code: string };

// Clôture ouvrante en début de ligne (langue facultative), contenu, clôture fermante seule sur sa ligne.
const FENCED_BLOCK = /^[ \t]*```[^\n`]*\n([\s\S]*?)\n?^[ \t]*```[ \t]*$/gm;

export function splitInstructionParts(text: string): InstructionPart[] {
  const parts: InstructionPart[] = [];
  let last = 0;
  for (const match of text.matchAll(FENCED_BLOCK)) {
    const before = text.slice(last, match.index);
    if (before.trim()) parts.push({ kind: 'text', text: before });
    parts.push({ kind: 'code', code: match[1] });
    last = match.index! + match[0].length;
  }
  if (last === 0) return [{ kind: 'text', text }];
  const after = text.slice(last);
  if (after.trim()) parts.push({ kind: 'text', text: after });
  return parts;
}
